<template>
  <div id="app">
    <s-app-layout :userinfo="user" @lock="lock">
      <a href="javascript:;" slot="logo">
        <div class="plateform-logo"><img src="./assets/logo.png" alt="" /></div>
      </a>
      <a href="javascript:;" slot="name" class="plateform-name" style="width:115px">
        <img src="./assets/name.png" alt="" />
      </a>

      <s-menu
        ref="navigationMenu"
        slot="menu"
        shrink
        :menu="menu"
        :active-name="activeMenuName"
        :open-names="openMenuNames"
        @shrinkstatus-change="syncActiveMenu"
        @transitionend.native="scrollToActiveMenu"
      ></s-menu>

      <div slot="navbar">
        <s-dropdown trigger="hover" transfer :customClass="['feedback']" @popper-show="popperShow">
          <s-icon
            icon="mail-fill"
            class="icon-btn"
            :class="{ feedbackdot: is_active }"
            style="font-size: 16px;position: relative;top: 1px;"
          ></s-icon>
          <div slot="content">
            <div v-if="!notifications.length" class="feedback-no-msg">No message</div>
            <div class="feedback-msg-wrapper">
              <div v-for="(msg, i) in notifications" :key="i" class="feedback-msg">
                <div class="title">Q&A Feedback</div>
                <div class="content">
                  <div v-if="msg.source === 1">
                    {{ msg.from_user }}&nbsp;{{ msg.verb }}
                    <a class="check" @click="routertoFeedback(msg)">
                      question#{{ msg.question_id }}
                    </a>
                    <span v-if="msg.verb === 'assigns'">to you</span>
                  </div>
                  <div v-if="msg.source !== 1">
                    <div>New Support Ticket #{{ msg.question_id }}:</div>
                    <a class="check" @click="routertoSupport(msg)">
                      {{
                        question_sources[msg.source] +
                          '_' +
                          question_types[msg.type] +
                          '_' +
                          msg.creator_country
                      }}
                    </a>
                    <span v-if="msg.verb === 'assigns'">is assigned to you</span>
                  </div>
                  <div class="date">
                    <s-icon icon="clock" style="font-size: 13px"></s-icon>
                    <span>{{ timeDiff(msg.ct) }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="notifications.length" class="more-msg">
              <a href="/feedback">View all messages</a>
            </div>
          </div>
        </s-dropdown>
      </div>

      <div slot="navbar">
        <s-icon
          icon="download"
          class="icon-btn"
          @click.native="getExportTask"
          style="font-size: 14px"
        ></s-icon>
      </div>

      <div slot="navbar">
        <s-icon
          icon="tools-fill"
          class="icon-btn"
          @click.native="getApiKey"
          style="font-size: 14px"
        ></s-icon>
      </div>

      <div slot="content" style="height:100%;">
        <keep-alive :include="includes">
          <transition name="router" mode="out-in">
            <router-view v-if="isRouterAlive"></router-view>
          </transition>
        </keep-alive>
      </div>
    </s-app-layout>

    <s-dialog></s-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import innerApiKey from './page/inner-api-key.vue'
import exportTask from './page/exportTask.vue'
import updateNotice from './page/updateNotice'

export default {
  name: 'app',
  provide() {
    return {
      reload: this.reload,
    }
  },
  created() {
    // 获取角色d对应id
    this.$store.dispatch('getRole')
    // 检查版本
    // this.checkVersion();
    this.getUreadStatus()
    this.getQuestionTypes()
  },
  mounted() {
    this.$starfish.init()
  },
  methods: {
    syncActiveMenu(status) {
      if (status === 'close') return
      this.openMenuNames =
        this.activeMenuName === -1 ? [] : [Number(String(this.activeMenuName).split('-')[0])]
      this.$nextTick(() => this.scrollToActiveMenu())
    },
    scrollToActiveMenu(event) {
      const menu = this.$refs.navigationMenu
      if (!menu || menu.shrinkstatus !== 'open') return
      const active =
        menu.$el.querySelector('.menu-item-selected') ||
        menu.$el.querySelector('.menu-item-active > .menu-submenu-title')
      if (!active || !active.offsetHeight || (event && !event.target.contains(active))) return
      // 只滚动左侧菜单，避免改变业务页面的滚动位置和焦点。
      const container = menu.$el.closest('.p-menu')
      const bounds = container.getBoundingClientRect()
      const item = active.getBoundingClientRect()
      if (item.top < bounds.top) container.scrollTop += item.top - bounds.top
      else if (item.bottom > bounds.bottom) container.scrollTop += item.bottom - bounds.bottom
    },
    reload() {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    },
    lock(e, status) {
      this.is_lock = status
    },
    getApiKey() {
      this.$starfish.dialog.open({
        component: innerApiKey,
        closeOnModal: false,
        onClose: data => {},
      })
    },
    getExportTask() {
      this.$starfish.dialog.open({
        component: exportTask,
        closeOnModal: false,
      })
    },
    // 监听页面是否有更新
    checkVersion() {
      // 每60s请求一次
      let interval
      interval = setInterval(() => {
        this.$http.get('/api/hook/front-refresh/').then(data => {
          if (data === 'modified') {
            let h = this.$createElement
            this.$starfish.notify({
              type: 'warning',
              title: 'Version Update',
              message: h(updateNotice),
              duration: 0,
            })
            // 检查到有更新，关掉定时器
            clearInterval(interval)
            interval = null
          }
        })
      }, 60000)
    },
    // 获取未读状态，刷新时请求一次之后每10分钟请求一次
    getUreadStatus() {
      this.$http.get('/api/feedback/message/unread/get/').then(res => {
        let unreadStatus = res.if_message_unread
        if (unreadStatus === 1) {
          this.is_active = true
        } else {
          this.is_active = false
        }
        this.getNotifications()
      })
      setInterval(() => {
        this.$http.get('/api/feedback/message/unread/get/').then(res => {
          let unreadStatus = res.if_message_unread
          if (unreadStatus === 1) {
            this.is_active = true
          } else {
            this.is_active = false
          }
        })
      }, 600000)
    },
    getQuestionTypes() {
      const youmi_source = 3
      this.$http.get(`/api/feedback/question/${youmi_source}/type/`).then(res => {
        for (let type of res.types) {
          this.question_types[type.id] = type.name
        }
      })
    },
    getNotifications() {
      if (this.is_active === true || this.notifications.length === 0) {
        this.$http
          .get('/api/feedback/message/get/')
          .then(res => {
            this.notifications = res.data
            for (let item of this.notifications) {
              if (item.operation === 0) {
                item.verb = 'assigns'
              }
              if (item.operation === 2 || item.operation === 5) {
                item.verb = 'changes'
              }
              if (item.operation === 3) {
                item.verb = 'answers your'
              }
            }
          })
          .catch(error => {
            this.notifyOpen('Error', this.executeError(error), 'error')
          })
      }
    },
    popperShow() {
      this.getNotifications()
      this.is_active = false
    },
    routertoFeedback(msg) {
      this.$router.push({ path: '/feedback', query: { tag: msg.tag, id: msg.question_id } })
    },
    routertoSupport(msg) {
      this.$router.push({ path: '/support', query: { id: msg.question_id } })
    },
  },
  watch: {
    activeMenuName: {
      immediate: true,
      handler() {
        this.syncActiveMenu()
      },
    },
    dataShrinkstatus(val) {
      console.log(val)
    },
  },
  data() {
    return {
      openMenuNames: [],
      is_lock: true,
      notifications: [],
      question_sources: {
        1: 'Demeter',
        2: 'Network',
        3: 'Youmi',
        4: 'Contact',
      },
      question_types: {},
      is_active: false,
      isRouterAlive: true,
    }
  },
  computed: {
    ...mapState(['user', 'menu', 'perm', 'role', 'includes']),
    activeMenuName() {
      let active = -1
      let bestScore = 0
      const menu = this.menu || []
      menu.forEach((group, groupIndex) => {
        const items = group.href ? [group] : group.items || []
        items.forEach((item, itemIndex) => {
          if (!item.href || item.external) return
          const route = this.$router.resolve(item.href).route
          // 详情、编辑页面沿用最近的共同父路由对应的菜单。
          let score = route.matched.reduce((best, record) => {
            return record.path !== '/' && this.$route.matched.includes(record)
              ? Math.max(best, record.path.length)
              : best
          }, 0)
          if (route.path.replace(/\/$/, '') === this.$route.path.replace(/\/$/, ''))
            score = Infinity
          if (score > bestScore) {
            bestScore = score
            active = group.href ? groupIndex : `${groupIndex}-${itemIndex}`
          }
        })
      })
      return active
    },
  },
}
</script>

<style>
#app {
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.router-enter-active {
  transition: all 0.2s ease-in-out;
}

.router-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}

.router-enter,
.router-leave-active {
  opacity: 0;
}

.layout-custom-ops > * {
  margin-left: 18px;
}

.layout-custom-ops .icon {
  margin-right: 0;
  font-size: 12px;
}

.icon-sf_user-fill.icon {
  margin-right: 18px;
  font-size: 14px;
}
.icon-btn {
  font-size: 14px;
}
.icon-btn:hover {
  color: #6f92eb;
}
.feedbackdot::after {
  content: '\e93e';
  display: block;
  color: #ec6a5f;
  font-size: 12px;
  position: absolute;
  top: -6px;
  right: -12px;
}
.feedback-no-msg {
  padding: 8px !important;
}
.feedback-msg {
  padding: 12px;
  border-bottom: 1px solid #e7e7e7;
  height: 72px;
  overflow: hidden;
}
.feedback-msg .title {
  font-weight: 500;
  font-size: 15px;
}
.feedback-msg .content {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: #8b8c8d;
  line-height: 1.5em;
}
.feedback-msg-wrapper .feedback-msg:last-of-type {
  border-bottom: none;
}
.feedback-msg .check {
  color: #6f92eb;
}
.date {
  font-size: 13px;
  margin-top: -7px;
  margin-left: 10px;
}
.more-msg {
  width: 127px;
  color: #6f92eb;
  margin: 0 auto 8px;
  font-size: 15px;
}
</style>
